module.exports = __webpack_public_path__ + "static/media/loading.4538febe.gif";